import React from 'react';

//axios
import axios from 'axios';
import axiosUrl from '../../axios/url';


export default function PasswordChange(param) {
    const [username, setUsername] = React.useState('');
    const [oldPassword, setOldPassword] = React.useState('');
    const [newPassword, setNewPassword] = React.useState('');
    const [newPassword2, setNewPassword2] = React.useState('');

    async function getPasswordChange(){
        var sendData = {
            "username": username,
            "oldPassword": oldPassword,
            "newPassword": newPassword
        }
        await axios.put(axiosUrl.passwordChange, sendData)
        .then( response => {
            console.log("password change success");
            alert("비밀번호가 변경되었습니다.");
            sessionStorage.setItem('loginToken', sessionStorage.tempToken);
            sessionStorage.removeItem("tempToken");
            
            window.location.href='/'
            
        })
        .catch(function (e) {
                console.error('[MEDIEX_CMS_2019_ERROR] Project.getPasswordChange - ' + e);
                console.error('[MEDIEX_CMS_2019_ERROR] axiosUrl - ' + axiosUrl.passwordChange);
        });

    }
    
    // handler
    function handleUsername(e){  setUsername(e.target.value); }
    function handleOldPassword(e){  setOldPassword(e.target.value); }
    function handleNewPassword(e){  setNewPassword(e.target.value); }
    function handleNewPassword2(e){  setNewPassword2(e.target.value); }
    function savePassword() {
        if(username !== '' && oldPassword !== '' && newPassword !== '' && newPassword2 !== '') {
            //패스워드 1와 2 비교
            if(newPassword === newPassword2) {
                getPasswordChange();
            } else {
                alert("비밀번호 두개가 일치하지 않습니다.");
            }
        } else {
            alert("모두 입력하여 주세요");
        }
    }


    return(    
        <div className="modal fade" id="passwordChangeModal"  name="passwordChangeModal" data-keyboard={param.check}  data-backdrop={param.check} tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog  modal-dialog-centered">
                <div className="modal-content">
                <div className="register-box">
                    <div className="register-logo">
                        <a href="/"><b>myHealth</b>CMS</a>
                    </div>

                    <div className="card">
                        <div className="card-body register-card-body">
                        <p className="login-box-msg">비밀번호 변경</p>

                            <div className="input-group mb-3">
                                <input type="email" className="form-control" placeholder="아이디" onChange={handleUsername} />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                    <span className="fas fa-envelope"></span>
                                    </div>
                                </div>
                            </div>

                            <div className="input-group mb-3">
                                <input type="password" className="form-control" placeholder="이전 비밀번호" onChange={handleOldPassword} />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                    <span className="fas fa-lock"></span>
                                    </div>
                                </div>
                            </div>

                            <div className="input-group mb-3">
                                <input type="password" className="form-control" placeholder="새 비밀번호" onChange={handleNewPassword} />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                    <span className="fas fa-lock"></span>
                                    </div>
                                </div>
                            </div>

                            <div className="input-group mb-3">
                                <input type="password" className="form-control" placeholder="새 비밀번호 확인" onChange={handleNewPassword2} />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                    <span className="fas fa-lock"></span>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="row d-block">
                                <div className="col-4 float-right">
                                    <button type="submit" className="btn btn-primary btn-block btn-flat" onClick={() => savePassword()}>변경하기</button>
                                </div>
                            </div>

                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
    );
}